export enum TrackedEvent {
    RefreshStalePage = 'RefreshStalePage',
    GuideMessageTemplateSelected = 'GuideMessageTemplateSelected',
    GuideOutOfOfficeUpdated = 'GuideOutOfOfficeUpdated',
    BulkMessageSent = 'BulkMessageSent',
    QuickSearchModalOpened = 'QuickSearchModalOpened',
    MembershipMessagingViewModeToggled = 'MembershipMessagingViewModeToggled',
    MembershipMessagingSizeToggled = 'MembershipMessagingSizeToggled',
    DocumentVaultFileViewed = 'DocumentVaultFileViewed',
    DocumentVaultFileDownloaded = 'DocumentVaultFileDownloaded',
    DocumentVaultFileRenamed = 'DocumentVaultFileRenamed',
    MembershipsExportedToCsv = 'MembershipsExportedToCsv',
    MembersExportedToCsv = 'MembersExportedToCsv',
    MoneyMapPublishedForPreview = 'MoneyMapPublishedForPreview',
    MoneyMapFinalizedForAction = 'MoneyMapFinalizedForAction',
    WorkflowItem = 'WorkflowItem',
}
